import type { ReactNode } from "react";

export type CheckboxFieldProps = {
    checked: boolean;
    onChange: (checked: boolean) => void;
    /** Visible label after the checkbox. */
    label: ReactNode;
    /** Native tooltip on the label text. */
    title?: string;
    disabled?: boolean;
    /** Uses `field-label-inline` (compact single-line) instead of `checkbox-label`. */
    inline?: boolean;
    className?: string;
};

/**
 * Standard panel checkbox: `field-label` + checkbox + label text (optional `title` on a wrapping span).
 */
export function CheckboxField({
    checked,
    onChange,
    label,
    title,
    disabled,
    inline,
    className,
}: CheckboxFieldProps) {
    const labelClass = [
        "field-label",
        inline ? "field-label-inline" : "checkbox-label",
        className,
    ]
        .filter(Boolean)
        .join(" ");

    const content = title ? <span title={title}>{label}</span> : label;

    return (
        <label className={labelClass}>
            <input
                type="checkbox"
                checked={checked}
                disabled={disabled}
                onChange={(e) => onChange(e.target.checked)}
            />
            {content}
        </label>
    );
}
